// removed by extract-text-webpack-plugin
module.exports = {"list":"src-components-QuoteList----index-module---list---b4CJf","container":"src-components-QuoteList----index-module---container---fH12n","quote":"src-components-QuoteList----index-module---quote---3wkiD","source":"src-components-QuoteList----index-module---source---3g_kS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/QuoteList/index.module.css
// module id = 324
// module chunks = 35783957827783